export default {"src":"/_next/static/media/BNB.55cf3128.svg","height":54,"width":54,"blurWidth":0,"blurHeight":0};